import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountViewModel } from 'projects/Administration/src/app/business-entities/account-view-model';
import { AccountService } from 'projects/Administration/src/app/business-services/account.service';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
})
export class ContactDetailsComponent implements OnInit {

  accountId: string;
  contactDetailResponse: any;
  contactList: any[] = [];
  totalCount: number = 0;
  accountsList: AccountViewModel[] = [];
  throttle = 100;
  scrollDistance = 1;
  startRecordNumber: number = 0;
  pageSize: number = 25;

  constructor(private accountService: AccountService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.accountId = this.accountService.accountId;
    this.accountService.accountListRequest.pageSize = this.pageSize;
    this.contactList = [];
    this.accountService.accountListRequest.startRecordNumber = 0;
    this.getContactDetailsById(this.accountId, this.accountService.accountListRequest.startRecordNumber, this.accountService.accountListRequest.pageSize);
  }


  async getContactDetailsById(id, startRecordNumber, numberOfRecord) {
    this.spinner.show();
    await this.accountService.getContactDetailsById(id, startRecordNumber, numberOfRecord).then((response) => {
      this.contactList.push(...this.contactDataMapper(response.responseObject));
      if (response.responseObject?.result?.errorCode == "404") {
        this.totalCount = 0;
      } else {
        if(this.contactList.length > 0) {
          this.totalCount = this.contactList[0].totalCount
        }

      }
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.contactList.length){
      this.accountService.accountListRequest.startRecordNumber = this.contactList.length;
      this.getContactDetailsById(this.accountId, this.accountService.accountListRequest.startRecordNumber, this.accountService.accountListRequest.pageSize);
    }
  }

  private contactDataMapper(contact: any) {
    let supperArray = [];
    if (contact && contact.length > 0) {
      for (let index = 0; index < contact.length; index++) {
        const element = contact[index];
        let single = Object();

        single.rowNumber = (this.accountService.accountListRequest.startRecordNumber + 1) + index;
        single.accountId = element.accountId;
        single.customerName = element.custName;
        single.addressLine1 = element.address1;
        single.addressLine2 = element.address2;
        single.createdDate = element.createdDate? new Date(element.createdDate + 'Z') : null;
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.customerNo = element.customerNo;
        single.isActive = element.isActive;
        single.sourceType = element.sourceType;
        single.mobileNo = element.mobileNo;
        single.email = element.email;
        single.city = element.city;
        single.state = element.state;
        single.country = element.country;
        single.pincode = element.pincode;
        single.totalCount = element.totalcount;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
}
